import React from 'react';
import Home2 from './page/home2';
import './normalize.css';

export const PropsContext = React.createContext({});

function App() {
  return (
    <section>
      <Home2 />
    </section>
  );
}

export default App;
